import {USER_CONNECTED} from '../events/signin';
import {pushNotification} from '@malt/joy-v2/src/js/notification';

Hop.defineModule('menu-email-validation', () => {
    const validationEmailResendLabel = Hop.message('menu.validation.email.resend');
    const validationEmailNotSentLabel = Hop.message('menu.validation.email.notsent');
    const accountDisabledLabel = Hop.message('menu.account.disabled');
    const validationEmailSentLabel = Hop.message('menu.validation.email.sent');

    function addUnreadCounters(userInfo) {
        if (!userInfo.connected) {
            return;
        }
        if (!(userInfo.unread && userInfo.unreadByIdentity)) {
            return;
        }

        if (document.querySelectorAll('.main-header-nav').length) {
            // new brand
            $('#inboxMainAction').append(`<span class="bubble w-bd">${userInfo.unread}</span>`);

            const unreadByIdentity = userInfo.unreadByIdentity || {};
            Object.keys(unreadByIdentity).forEach((identityId) => {
                $('#inboxLinkFor' + identityId).append(`<span class="bubble w-bd">${unreadByIdentity[identityId]}</span>`);
            });
        } else {
            // new menu
            $('.js-mainheader-inbox').append('<i class="mainheader-badge" id="mainHeaderBadgeMail">' + userInfo.unread + '</i>');

            const unreadByIdentity = userInfo.unreadByIdentity || {};
            Object.keys(unreadByIdentity).forEach((identityId) => {
                $('#inboxLinkFor' + identityId + ' .js-unread-count').text('(' + unreadByIdentity[identityId] + ')');
            });
        }
    }

    Hop.events.on(USER_CONNECTED, (userInfo) => {
        // ensure menu items are present, since they are added with the same listening mechanism
        setTimeout(addUnreadCounters.bind(undefined, userInfo), 10);
    });

    $.ajax({
        url: '/api/user',
        cache: false,
        dataType: 'json',
        success: (userInfo) => {
            if (!userInfo.connected) {
                return;
            }

            addUnreadCounters(userInfo);

            const emailVerified = userInfo.enable === true || userInfo.emailToBeVerified === false; // deprecated

            if (emailVerified || $('#alert-anchor').length !== 1) {
                return;
            }

            pushNotification(accountDisabledLabel + " <a id='resend-signup-mail' href='#'> " + validationEmailResendLabel + '</a>');

            const $resendSignupMailButton = $('#resend-signup-mail');
            $resendSignupMailButton.click(() => {
                $.ajax({
                    url: '/api/emailvalidation/resenddemand',
                    type: 'POST',
                    data: {},
                })
                    .done(() => {
                        pushNotification(validationEmailSentLabel, {level: 'success'});
                        $resendSignupMailButton.parent().parent().remove();
                    })
                    .error((id, jqXhr, textStatus) => {
                        pushNotification(validationEmailNotSentLabel + textStatus, {level: 'error'});
                        $resendSignupMailButton.parent().parent().remove();
                    });
            });
        },
    });
});
